import { useState, useEffect } from 'react';
import Papa from 'papaparse';

// This is the native Google Visualization API link for the client's Google Sheet
const GOOGLE_SHEET_JSON_URL = "https://docs.google.com/spreadsheets/d/17qxE03YzRiZTUdYhAuGDSlVYPRe_IHLIpGjUK8Se6EQ/gviz/tq?tqx=out:json";

export function useGoogleSheets() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSheetData = async () => {
      try {
        const timeBuster = new Date().getTime();
        const response = await fetch(`${GOOGLE_SHEET_JSON_URL}&t=${timeBuster}`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch data from Google Sheets');
        }
        
        const text = await response.text();
        // Strip out the google.visualization.Query.setResponse(...) wrapper
        const jsonStr = text.substring(text.indexOf('{'), text.lastIndexOf('}') + 1);
        const jsonData = JSON.parse(jsonStr);
        
        const cols = jsonData.table.cols.map(c => c.label);
        const rows = jsonData.table.rows.map(row => {
          const rowData = {};
          cols.forEach((colName, index) => {
            rowData[colName] = row.c[index] ? row.c[index].v : null;
          });
          return rowData;
        });

        const parsedData = transformData(rows);
        setData(parsedData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching/parsing Google Sheets JSON:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchSheetData();
  }, []);

  // Transform flat CSV rows into the nested object structure expected by the app
  const transformData = (rows) => {
    const structuredData = {
      gastonia: {},
      lakeNorman: {}
    };

    rows.forEach((row, index) => {
      const campus = String(row.Campus || '').trim(); // 'gastonia' or 'lakeNorman'
      const type = String(row.Type || '').trim();     // 'saturday', 'hybrid', etc.
      
      if (!campus || !type || !structuredData[campus]) return;

      if (!structuredData[campus][type]) {
        structuredData[campus][type] = [];
      }

      structuredData[campus][type].push({
        id: `${campus}-${type}-${index}`,
        startDate: String(row.StartDate || '').trim(),
        endDate: String(row.EndDate || '').trim(),
        time: String(row.Time || '').trim(),
        seats: parseInt(row.Seats) || 0,
        isFull: typeof row.IsFull === 'boolean' ? row.IsFull : String(row.IsFull || '').trim().toLowerCase() === 'true',
        isWaitlistOnly: typeof row.IsWaitlistOnly === 'boolean' ? row.IsWaitlistOnly : String(row.IsWaitlistOnly || '').trim().toLowerCase() === 'true',
        isFeatured: typeof row.IsFeatured === 'boolean' ? row.IsFeatured : String(row.IsFeatured || '').trim().toLowerCase() === 'true'
      });
    });

    return structuredData;
  };

  return { data, loading, error };
}
